import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { Button } from 'reactstrap';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import Content from '../../../layout/Content';
import Table from '../../../common/Table';
import { ITINERARY_BOARDING_REPORT_PATH } from '../../../../config/paths';
import {
  getAllItineraryBoardingReports,
  clearItineraryBoardingReports,
  exportBoardingReportFile,
} from '../../../../actions';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ItineraryBoardingReportSearchForm from './ItineraryBoardingReportSearchForm';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { ITINERARY_BOARDING_REPORT_COLUMNS } from '../../../../config/columns';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';

export const ItineraryBoardingReport = ({
  dispatchGetAllItineraryBoardingReports,
  dispatchClearItineraryBoardingReports,
  dispatchExportBoardingExcel,
  loading,
  breadcrumbs,
  boardingItineraries,
}) => {
  useEffect(() => () => dispatchClearItineraryBoardingReports(), []);

  const buildQuery = (formValues) => ({
  boardingAgencyId: formValues.agency.value,
  destinationLocationIds: formValues.locationIds ? formValues.locationIds.map(({ value }) => value) : null,
  fromDateString: tzNormalizeDate({
    date: formValues.fromDateString,
    format: INT_DATE_FORMAT,
  }),
  toDateString: tzNormalizeDate({
    date: formValues.toDateString,
    format: INT_DATE_FORMAT,
  }),
});

const onSubmit = (formValues) =>
  dispatchGetAllItineraryBoardingReports(buildQuery(formValues));

const handleExport = (formValues) =>
  dispatchExportBoardingExcel(buildQuery(formValues));

const extraButtons = ({ handleSubmit }) => (
  <Button
    onClick={handleSubmit(handleExport)}
    color="success"
    className="mr-2"
    disabled={loading}
  >
    <i className="fa fa-file-excel-o mr-2" />
    Exportar
  </Button>
);

  const title = 'Consulta de Boletos y Embarques';

  const subtitle = (
    <>
      Consulta el <strong>resumen de embarques o boletos por itinerario</strong>{' '}
      por rango de fechas, agencia de embarque y ubicación destino.
    </>
  );

  const content = boardingItineraries.get('content');
  const data = content && content.toJS ? content.toJS() : content;

  const pageContent = (
    <>
      <ItineraryBoardingReportSearchForm
        onSubmit={onSubmit}
        loading={loading}
        extraButtons={extraButtons}
        initialValues={{
          fromDateString: tzNormalizeDate(),
          toDateString: tzNormalizeDate(),
        }}
      />

      <hr />

      <Table
        columns={ITINERARY_BOARDING_REPORT_COLUMNS}
        data={data}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        manual={false}
        loading={loading}
        defaultFilterMethod={filterMethodCaseInsensitive}
        filterable
      />
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title={title}
      subtitle={subtitle}
      content={pageContent}
    />
  );
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Consulta de Boletos y Embarques',
      href: ITINERARY_BOARDING_REPORT_PATH,
    },
  ],
  loading: ItineraryUnit.ItineraryBoardingReport.getIn(['all', 'loading']),
  boardingItineraries: ItineraryUnit.ItineraryBoardingReport.getIn([
    'all',
    'content',
  ]),
});

const mapDispatchToProps = {
  dispatchGetAllItineraryBoardingReports: getAllItineraryBoardingReports,
  dispatchClearItineraryBoardingReports: clearItineraryBoardingReports,
  dispatchExportBoardingExcel: exportBoardingReportFile
};

ItineraryBoardingReport.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetAllItineraryBoardingReports: PropTypes.func.isRequired,
  dispatchClearItineraryBoardingReports: PropTypes.func.isRequired,
  dispatchExportBoardingExcel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  boardingItineraries: PropTypes.instanceOf(Immutable.Map).isRequired,
};

ItineraryBoardingReport.defaultProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItineraryBoardingReport);
